module.exports = __webpack_public_path__ + "img/table-icon-instagram.eba4a764.jpg";